<template>
  <div>
    <div class="formBox margbot"  ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox ">
            <el-form-item label="业务期间:" >
              <el-date-picker
              v-model="searchFrom.yuefen"
              type="monthrange" format="yyyy-MM" value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
            </el-date-picker>
            </el-form-item>
            <el-form-item label="审核状态:" >
              <el-select v-model="searchFrom.auditStatus" placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="不审核" value="0" ></el-option>
                <el-option  label="待审核" value="1" ></el-option>
                <el-option  label="审核通过" value="2" ></el-option>
                <el-option  label="审核驳回" value="3" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务部门:" v-if="usertype==2">
              <el-select  v-model="searchFrom.createSubdepartmentCode" filterable placeholder="请选择" >
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="结算客户:" >
              <el-select  v-model="searchFrom.customerName" filterable placeholder="请选择" >
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称:" >
              <el-select v-model="searchFrom.projectType" filterable placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in xmList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务类型:" >
              <el-select v-model="searchFrom.businessName" placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="009M0I0100" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200" v-if="btnFlg[1]">
            <el-button type="primary"  @click="exportFn()" :disabled="isDisable">导出</el-button>
          </el-form-item>
          <el-form-item>
            <p class="margin0">应收金额合计:<span class="red">{{map.amountReceivable}}</span>元</p>
          </el-form-item>
          <el-form-item>
            <p class="margin0">不含税金额合计:<span class="red">{{map.priceExcludTax}}</span>元</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" @row-click="handleRowClick"  highlight-current-row  bordersize="mini" class="tableComent" height="100%" style="width: 100%" center border >
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column prop="createSubdepartmentName" v-if="usertype==2" min-width="200" label="业务部门"></el-table-column>
        <el-table-column prop="businessDate" width="120" :formatter="emptyFn" label="业务期间"> </el-table-column>
        <el-table-column  width="120" :formatter="emptyFn" label="审核状态" v-if="usertype!=2">
          <template scope="scope">
             <div>
              <span   v-if="scope.row.auditStatus==='不审核'">不审核</span>
              <span  style="color: #F56C6C;" v-if="scope.row.auditStatus==='待审核'">待审核</span>
              <span  style="color: #67C23A;" v-else-if="scope.row.auditStatus=='审核通过'">审核通过</span>
              <span  style="color: #E6A23C;" v-else-if="scope.row.auditStatus=='审核驳回'">审核驳回</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" min-width="180" :formatter="emptyFn" label="结算客户"> </el-table-column>
        <el-table-column prop="projectType" min-width="120" :formatter="emptyFn" label="项目名称"> </el-table-column>
        <el-table-column prop="businessName" min-width="120" :formatter="emptyFn" label="业务类型"> </el-table-column>
        <el-table-column prop="liquidatedAmount" min-width="120" :formatter="emptyFn" label="结算量" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="amountReceivable" min-width="120" :formatter="emptyFn" label="应收金额(元)">
           <template scope="scope">
            <div>
              <!-- {{scope.row.amountReceivable}} -->
              <el-button type="text" size="mini" @click="yingshouFn(scope.row)" >{{scope.row.amountReceivable}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="taxRate" min-width="100" :formatter="emptyFn" label="税率(%)"></el-table-column>
        <el-table-column prop="priceExcludTax" min-width="130" :formatter="emptyFn" label="不含税金额(元)"></el-table-column>
        <el-table-column prop="makeTicketYn" min-width="80" v-if="invoiceMark==1" :formatter="emptyFn" label="是否开票"></el-table-column>
        <el-table-column prop="invoiceOn" :show-overflow-tooltip="true" min-width="130"  v-if="invoiceMark==1" :formatter="emptyFn" label="发票号">
          <template scope="scope">
            <div>
              <el-tooltip effect="dark" :content="scope.row.invoiceOn" placement="right-end">
                <span>{{scope.row.invoiceOn}}</span>
                <div slot="content" style="cursor: pointer;" @click="copyBtn(scope.row.invoiceOn)">复制</div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceMonth" min-width="80"  v-if="invoiceMark==1" :formatter="emptyFn" label="开票月份"></el-table-column>

      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 合计明细 -->
   <YSmingxi v-if="mingxiMark"  :rowData="rowData" :mingxiMark.sync='mingxiMark'></YSmingxi>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findCustomerMonthList, findCustomerMonthTotal, getDictionaryDetailList, findCustomerList } from '@/api/newTMS'
import { getCurrUserDepartment } from '@/api/newCrm'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import YSmingxi from './YSmingxi'
export default {
  props: ['invoiceMark', 'usertype', 'createSubdepartmentCode', 'businessDate'],
  components: {
    YSmingxi
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      isDisable: false,
      emptyFn: emptyFn,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      map: {},
      loading: false,
      kehuList: [],
      YWLXlist: [],
      xmList: [],
      bumenList: [],
      rowData: {},
      mingxiMark: false,
      btnFlg: [],
      btnIdArr: ['009M0I0100', '009M0I0200', '009M0I0300']
    }
  },
  created () {
    if (this.invoiceMark == 1) {
      this.btnIdArr = ['01N01F0900', '01N01F0A00']
      this.btnFlg = getBtn(this.btnIdArr, '/yikaipiaoSR')
    } else if (this.invoiceMark == 2) {
      this.btnIdArr = ['01N01G0900', '01N01G0A00']
      this.btnFlg = getBtn(this.btnIdArr, '/weikaipiaoSR')
    }
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.xmList = res })
    findCustomerList({ flag: this.usertype, ieMark: 1 }).then(res => { this.kehuList = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    if (this.businessDate) { // 从列表跳转过来
      this.$set(this.searchFrom, 'yuefen', [this.businessDate, this.businessDate])
    } else {
      this.$set(this.searchFrom, 'yuefen', this.getriqi())
    }
    if (this.createSubdepartmentCode) { // 从列表跳转过来
      this.$set(this.searchFrom, 'createSubdepartmentCode', this.createSubdepartmentCode)
    } else {
      if (this.usertype == 2) { // 如果是财务
        this.$set(this.searchFrom, 'createSubdepartmentCode', null)
      } else {
        this.$set(this.searchFrom, 'createSubdepartmentCode', localStorage.getItem('orgSubCode'))
      }
    }
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    // 复制
    copyBtn (message) {
      // navigator.clipboard.writeText 该方法需要在安全域下才能够使用，比如：https 协议的地址、127.0.0.1、localhost
      navigator.clipboard
        .writeText(message)
        .then(() => {
          this.$message.success('复制成功')
        }).catch((err) => {
        })
    },
    // 应收明细
    yingshouFn (row) {
      this.rowData = row
      this.mingxiMark = true
    },
    getriqi () {
      const months = []
      const date = new Date()
      for (let i = 0; i < 3; i++) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        months.push(`${year}-${month}`)
        date.setMonth(date.getMonth() - 1)
      }

      return [months[2], months[0]] // 返回数组，如 ["2025-04", "2025-06"]
    },
    // 导出
    exportFn () {
      this.searchFrom.ieMark = 1// 收支标记 1：收入 2：成本
      this.searchFrom.invoiceMark = this.invoiceMark// 1：已开票与无票收入/已开票成本 2：未开票收入/未开票成本
      this.searchFrom.flag = this.usertype// 角色标记：1.业务、审批人 2.财务
      if (this.searchFrom.yuefen) {
        this.searchFrom.businessDateStart = this.searchFrom.yuefen[0]
        this.searchFrom.businessDateEnd = this.searchFrom.yuefen[1]
      } else {
        this.searchFrom.businessDateStart = null
        this.searchFrom.businessDateEnd = null
      }
      exportExcel(
        this.global.tmsPlus + '/customerMonthly/findCustomerMonthListExportByExcel',
        this.searchFrom,
        '月客户收入'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.row = row
      this.$refs.table.toggleRowSelection(row)
    },
    searchFn () {
      this.getList()
    },
    // 获取货物列表
    getList () {
      this.searchFrom.ieMark = 1// 收支标记 1：收入 2：成本
      this.searchFrom.invoiceMark = this.invoiceMark// 1：已开票与无票收入/已开票成本 2：未开票收入/未开票成本
      this.searchFrom.flag = this.usertype// 角色标记：1.业务、审批人 2.财务
      if (this.searchFrom.yuefen) {
        this.searchFrom.businessDateStart = this.searchFrom.yuefen[0]
        this.searchFrom.businessDateEnd = this.searchFrom.yuefen[1]
      } else {
        this.searchFrom.businessDateStart = null
        this.searchFrom.businessDateEnd = null
      }
      this.loading = true
      findCustomerMonthList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.$message.error(error.message)
      })
      findCustomerMonthTotal(this.searchFrom).then(res => {
        this.map = res
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.searchFrom, 'yuefen', this.getriqi())
      if (this.usertype == 2) { // 如果是财务
        this.$set(this.searchFrom, 'createSubdepartmentCode', null)
      } else {
        this.$set(this.searchFrom, 'createSubdepartmentCode', localStorage.getItem('orgSubCode'))
      }
    }
  }
}
</script>
<style scoped lang='less'>

/deep/.el-form{
  width: 100%;
}
/deep/.searchBox .el-input--mini .el-input__inner{
  width: 150px !important;
}

</style>
